module.exports = __webpack_public_path__ + "img/gridGalleryMedia.dc09b23a.svg";